import { render, staticRenderFns } from "./PointsOfInterest.vue?vue&type=template&id=4670c20a"
import script from "./PointsOfInterest.vue?vue&type=script&lang=js"
export * from "./PointsOfInterest.vue?vue&type=script&lang=js"
import style0 from "./PointsOfInterest.vue?vue&type=style&index=0&id=4670c20a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports